export default "__VITE_ASSET__8bdbea71__"